import $ from "jquery";
import app, { u_, vuwer } from "@@assets/scripts/common";
import "@pressmedia/vuwcolony";
import createModule from "./_createModule";
import _addCategorySection from "./_addCategorySection";
import { showPopupSlides } from "./_popupSlides";

vuwer.add("itemsSection", {
	selector: "#items_section",
	module: createModule("works"),
	_addCategorySection,
	
	async onReadyFirst($self) {
		if(!$self) {
			return false;
		}
		
		$self.on("click", '.echoed-data[data-key="images"]', e => {
			e.preventDefault();
			const $elm = $(e.currentTarget);
			const index = parseInt( $elm.attr("data-index") );
			const $slideWrapper = $elm.parent().clone();
			showPopupSlides($slideWrapper, index);
		});
		
		await this.promise;
		
		const { items } = this.module;
		const { dataParams } = this.module.config;
		if(
			!u_.isObject(items) ||
			!items.length ||
			!u_.isObject(items.byCategory) ||
			!u_.isObject(dataParams) ||
			!u_.isObject(dataParams.category) ||
			!u_.isObject(dataParams.category.dataOption)
		) {
			$self.remove();
			return false;
		}
		
		const categories = dataParams.category.dataOption;
		
		Object.keys(categories).forEach(categoryKey => {
			const list = items.byCategory[categoryKey];
			if( !Array.isArray(list) ) {
				return false;
			}
			
			const categoryName = categories[categoryKey];
			
			this._addCategorySection(this, categoryKey, categoryName, list);
		});
	}
	
}, function() {
	this.promise = this.module.loadConfig((err, res) => {
		if(!err) {
			const { template } = res;
			this.setProp({ template });
			return this.module.loadItems();
		}
	});
	
	const dataKey = this.module.getDataKey();
	app[dataKey] = this.module;
});
